import { render, staticRenderFns } from "./importgiftcards.vue?vue&type=template&id=6a5365de&"
import script from "./importgiftcards.vue?vue&type=script&lang=js&"
export * from "./importgiftcards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports